import { NAME } from "./constants"

export const isFetching = (state) => state[NAME].isFetching
export const organization = (state) => state[NAME].organization
export const name = (state) => organization(state).name
export const color = (state) => organization(state).color
export const activeField = (state) => state[NAME].activeField
